// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wh-100[data-v-23e52e2c] {\n  width: 100%;\n  height: 100%;\n}\n[data-v-23e52e2c] .enterpriseBody .tabfixed.fixed {\n  max-width: unset !important;\n  top: 0 !important;\n}\n", ""]);
// Exports
module.exports = exports;
